// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"map-blocked"},"nodeName":"g","children":[{"attributes":{"id":"fill2","fill":"transparent","d":"M18 21.5C20.4853 21.5 22.5 19.4853 22.5 17C22.5 14.5147 20.4853 12.5 18 12.5C15.5147 12.5 13.5 14.5147 13.5 17C13.5 19.4853 15.5147 21.5 18 21.5Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M15 6.5L9 3L3 6.5V20L9 17.5M15 6.5L21 4V9.5M15 6.5V9.5M9 17.5V3.5M9 17.5L10.5 18.375","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M20.4749 14.5251L15.5251 19.4749M21.182 20.182C19.4246 21.9393 16.5754 21.9393 14.818 20.182C13.0607 18.4246 13.0607 15.5754 14.818 13.818C16.5754 12.0607 19.4246 12.0607 21.182 13.818C22.9393 15.5754 22.9393 18.4246 21.182 20.182Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-map-blocked')
export default class MapBlockedIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'map-blocked',
    }
  }
}
